import { AnyAction } from 'redux';

import * as constants from 'redux/constants/documentsTypes.constants';
import { ITableUpdate } from 'types/table.types';
import { IDocumentsTypesFormData } from 'views/DocumentsTypesView/components/DocumentsTypesForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.DOCUMENTS_TYPES_ON_DELETE_REQUESTED,
  id,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.DOCUMENTS_TYPES_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.DOCUMENTS_TYPES_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: IDocumentsTypesFormData, id?: string): AnyAction => ({
  type: constants.DOCUMENTS_TYPES_ON_SAVE_REQUESTED,
  formData,
  id,
});
